// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
body:has(.onboarding-container),
body:has(.onboarding-page) {
  overflow: scroll !important;
  overflow-x: hidden !important;
}

.onboarding-container {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--secondary-surface-color) 0%, var(--tertiary-surface-color) 100%);
  position: relative;
  overflow: hidden;
}
.onboarding-container .onboarding-logo {
  position: absolute;
  top: 40px;
  right: 60px;
  z-index: 10;
}
.onboarding-container .onboarding-logo img {
  height: 40px;
}

.onboarding-welcome-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background: var(--main-surface-color);
  overflow-x: hidden;
  overflow-y: auto;
}
.onboarding-welcome-page .welcome-logo {
  position: absolute;
  height: 32px;
  left: calc(83.33% + 50px);
  top: 64px;
  width: 130px;
  z-index: 10;
}
.onboarding-welcome-page .welcome-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.onboarding-welcome-page .welcome-greeting {
  position: absolute;
  left: 60px;
  top: 64px;
  font-family: "Medium Sans", sans-serif;
  font-size: 40px;
  line-height: 1.2;
  margin: 0;
  z-index: 10;
}
.onboarding-welcome-page .welcome-greeting .welcome-text {
  color: var(--tertiary-text-color);
}
.onboarding-welcome-page .welcome-greeting .user-name {
  font-family: "Semi Sans", sans-serif;
  color: var(--primary-text-color);
}
.onboarding-welcome-page .welcome-content-section {
  position: absolute;
  left: 60px;
  top: 449px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  z-index: 10;
  padding-bottom: 40px;
}
.onboarding-welcome-page .welcome-content-section .welcome-title {
  margin: 0;
  font-family: "General Sans", sans-serif;
  font-size: 64px;
  font-weight: 600;
  line-height: 1.2;
  background: var(--home-page-elective-selector);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}
.onboarding-welcome-page .welcome-content-section .welcome-title span {
  display: block;
}
.onboarding-welcome-page .welcome-content-section .welcome-description {
  margin: 0;
  font-family: "Medium Sans", sans-serif;
  font-size: 22px;
  line-height: 1.4;
  color: var(--tertiary-text-color);
  max-width: 50%;
}
.onboarding-welcome-page .welcome-start-button {
  white-space: nowrap;
  position: fixed;
  right: 240px;
  bottom: 135px;
  transform: translate(50%, 50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 32px;
  border-radius: 8px;
  border: none;
  background: rgb(80, 149, 252);
  box-shadow: 0 0 20px rgba(80, 149, 252, 0.4), 0 4px 12px rgba(80, 149, 252, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: "Semi Sans", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.3px;
  color: #ffffff;
  z-index: 1000;
}
.onboarding-welcome-page .welcome-start-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);
  pointer-events: none;
  opacity: 1;
}
.onboarding-welcome-page .welcome-start-button:hover:not(:disabled) {
  transform: translate(50%, 50%) translateY(-2px);
  box-shadow: 0 0 25px rgba(80, 149, 252, 0.5), 0 6px 16px rgba(80, 149, 252, 0.35), 0 2px 4px rgba(0, 0, 0, 0.1);
  background: rgb(90, 159, 255);
}
.onboarding-welcome-page .welcome-start-button:active:not(:disabled) {
  transform: translate(50%, 50%) translateY(0);
  box-shadow: 0 0 15px rgba(80, 149, 252, 0.3), 0 2px 6px rgba(80, 149, 252, 0.25);
  transition: all 0.1s ease;
}
.onboarding-welcome-page .welcome-start-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: translate(50%, 50%);
}
.onboarding-welcome-page .welcome-start-button:focus-visible {
  outline: 2px solid rgba(80, 149, 252, 0.5);
  outline-offset: 4px;
}

.layered-background-new {
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}
.layered-background-new .layer-new {
  position: absolute;
  pointer-events: none;
  filter: blur(1px);
}
.layered-background-new .layer-new.layer-1-new {
  height: 424px;
  width: 698px;
  right: -50px;
  bottom: -50px;
  opacity: 0.02;
  border-radius: 100px;
  background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);
  box-shadow: 0 0 40px rgba(80, 149, 252, 0.1);
}
.layered-background-new .layer-new.layer-2-new {
  height: 344px;
  width: 598px;
  right: 20px;
  bottom: 20px;
  opacity: 0.04;
  border-radius: 80px;
  background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);
  box-shadow: 0 0 30px rgba(80, 149, 252, 0.15);
}
.layered-background-new .layer-new.layer-3-new {
  height: 264px;
  width: 500px;
  right: 40px;
  bottom: 40px;
  opacity: 0.08;
  border-radius: 60px;
  background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);
  box-shadow: 0 0 20px rgba(80, 149, 252, 0.15);
}
.layered-background-new .layer-new.layer-4-new {
  height: 184px;
  width: 399px;
  right: 60px;
  bottom: 60px;
  opacity: 0.12;
  border-radius: 40px;
  background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);
  box-shadow: 0 0 20px rgba(80, 149, 252, 0.25);
}
.layered-background-new .layer-new.layer-5-new {
  height: 106px;
  width: 298px;
  right: 80px;
  bottom: 80px;
  opacity: 0.16;
  border-radius: 20px;
  background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);
  box-shadow: 0 0 15px rgba(80, 149, 252, 0.3);
}

.submit-button-figma-new {
  position: fixed;
  right: 225px;
  bottom: 135px;
  transform: translate(50%, 50%);
  cursor: pointer;
  min-width: 200px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 32px;
  border-radius: 8px;
  border: none;
  background: rgb(80, 149, 252);
  font-family: "Semi Sans", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.3px;
  color: #ffffff;
  z-index: 1000;
  pointer-events: auto;
  white-space: nowrap;
  box-shadow: 0 0 20px rgba(80, 149, 252, 0.4), 0 4px 12px rgba(80, 149, 252, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.submit-button-figma-new::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);
  pointer-events: none;
  opacity: 1;
}
.submit-button-figma-new:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: translate(50%, 50%);
  box-shadow: none;
  min-width: 200px;
  pointer-events: none;
}
.submit-button-figma-new:hover:not(:disabled) {
  transform: translate(50%, 50%) translateY(-2px);
  box-shadow: 0 0 25px rgba(80, 149, 252, 0.5), 0 6px 16px rgba(80, 149, 252, 0.35), 0 2px 4px rgba(0, 0, 0, 0.1);
  background: rgb(90, 159, 255);
}
.submit-button-figma-new:active:not(:disabled) {
  transform: translate(50%, 50%) translateY(0);
  box-shadow: 0 0 15px rgba(80, 149, 252, 0.3), 0 2px 6px rgba(80, 149, 252, 0.25);
  transition: all 0.1s ease;
}
.submit-button-figma-new:focus-visible {
  outline: 2px solid rgba(80, 149, 252, 0.5);
  outline-offset: 4px;
}
@media (max-width: 1199px) {
  .submit-button-figma-new {
    position: fixed;
    right: auto;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 80px);
    max-width: 400px;
    padding: 16px 24px;
    font-size: 18px;
  }
  .submit-button-figma-new:disabled {
    transform: translateX(-50%);
  }
  .submit-button-figma-new:hover:not(:disabled) {
    transform: translateX(-50%) translateY(-2px);
  }
  .submit-button-figma-new:active:not(:disabled) {
    transform: translateX(-50%) translateY(0);
  }
}
@media (max-width: 768px) {
  .submit-button-figma-new {
    width: calc(100% - 40px);
    max-width: 400px;
    font-size: 16px;
    height: 48px;
    padding: 16px 32px;
  }
}

.onboarding-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  background: var(--main-surface-color);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 200px;
}
.onboarding-page .onboarding-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}
.onboarding-page .personal-details-background {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}
.onboarding-page .personal-details-background .bg-layer {
  position: absolute;
  box-shadow: -2px -2px 20px 0px rgba(34, 92, 180, 0.25);
}
.onboarding-page .personal-details-background .bg-layer.bg-layer-1 {
  height: 318px;
  width: 524px;
  left: calc(58.33% + 80px);
  top: 489px;
  opacity: 0.2;
  border-radius: 100px;
  background: linear-gradient(-44.28deg, rgb(216, 220, 227) 2.4%, rgb(0, 103, 255) 98.5%);
}
.onboarding-page .personal-details-background .bg-layer.bg-layer-2 {
  height: 258px;
  width: 449px;
  left: calc(66.67% + 10px);
  top: 529px;
  opacity: 0.4;
  border-radius: 80px;
  background: linear-gradient(-42.72deg, rgb(216, 220, 227) 2.4%, rgb(0, 103, 255) 98.5%);
}
.onboarding-page .personal-details-background .bg-layer.bg-layer-3 {
  height: 198px;
  width: 375px;
  left: calc(66.67% + 59px);
  top: 569px;
  opacity: 0.8;
  border-radius: 60px;
  background: linear-gradient(-40.29deg, rgb(216, 220, 227) 2.4%, rgb(0, 103, 255) 98.5%);
}
.onboarding-page .personal-details-background .bg-layer.bg-layer-4 {
  height: 138px;
  width: 299px;
  left: calc(75% - 10px);
  top: 609px;
  opacity: 0.12;
  border-radius: 40px;
}
.onboarding-page .personal-details-background .bg-layer.bg-layer-5 {
  height: 80px;
  width: 224px;
  left: calc(75% + 40px);
  top: 648px;
  opacity: 0.16;
  border-radius: 20px;
  background: linear-gradient(-29.73deg, rgb(216, 220, 227) 2.4%, rgb(0, 103, 255) 98.5%);
}
.onboarding-page .onboarding-header {
  position: relative;
  left: 60px;
  top: 60px;
  width: 419px;
  max-width: calc(100% - 120px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  margin-bottom: 20px;
}
@media (max-width: 1199px) {
  .onboarding-page .onboarding-header {
    left: 40px;
    max-width: calc(100% - 80px);
  }
}
@media (max-width: 768px) {
  .onboarding-page .onboarding-header {
    left: 20px;
    top: 32px;
    max-width: calc(100% - 40px);
    margin-bottom: 0;
  }
}
.onboarding-page .onboarding-header .step-indicators {
  position: relative;
  width: 419px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper .step-progress-line {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 6px;
  background: var(--quartinary-surface-color);
  z-index: 1;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper .step-progress-line::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: var(--progress-width, 69px);
  background: var(--accent-primary-blue-color);
  transition: width 0.3s ease;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper .step {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 120px;
  background: var(--quartinary-surface-color);
  border: 1px solid var(--border-color);
  color: var(--quinary-text-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Semi Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  z-index: 2;
  transition: all 0.3s ease;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper .step.completed {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
  box-shadow: none;
}
.onboarding-page .onboarding-header .step-indicators .step-indicator-wrapper .step.active {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
  box-shadow: none;
}
.onboarding-page .onboarding-header .onboarding-logo {
  height: 32px;
  width: 130px;
  position: relative;
}
.onboarding-page .onboarding-header .onboarding-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.onboarding-page .onboarding-form {
  position: relative;
  left: 60px;
  top: 140px;
  width: calc(100% - 520px);
  max-width: 1320px;
  display: flex;
  flex-direction: column;
  gap: 34px;
  z-index: 100;
  margin-bottom: 100px;
  padding-bottom: 200px;
  overflow-x: hidden;
}
@media (max-width: 1199px) {
  .onboarding-page .onboarding-form {
    width: calc(100% - 120px);
    max-width: none;
    left: 40px;
    top: 100px;
    margin-bottom: 120px;
    padding-bottom: 120px;
  }
}
@media (max-width: 768px) {
  .onboarding-page .onboarding-form {
    width: calc(100% - 40px);
    left: 20px;
    top: 53px;
    gap: 24px;
    padding-bottom: 100px;
    margin-bottom: 0;
  }
}
.onboarding-page .onboarding-form .onboarding-back-arrow {
  display: flex;
}
.onboarding-page .onboarding-form .onboarding-back-arrow .material-symbols-outlined {
  font-size: 32px;
  font-weight: 400;
  color: #101828;
}
.onboarding-page .onboarding-form .input-container {
  gap: 12px;
  white-space: inherit;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .input-container .input-label {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--secondary-text-color);
  margin-bottom: 0;
}
.onboarding-page .onboarding-form .input-container .input-label .required {
  color: var(--accent-primary-red-color);
}
.onboarding-page .onboarding-form .input-container .select-field {
  height: 60px;
}
.onboarding-page .onboarding-form .input-container .input-field {
  height: 60px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  color: #333b48;
  z-index: 101;
  opacity: 1;
}
.onboarding-page .onboarding-form .input-container .input-field:disabled {
  background-color: #f5f5f5 !important;
  color: #94a0b3 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
  border-color: #e0e0e0 !important;
}
.onboarding-page .onboarding-form .input-container .input-field::placeholder {
  color: var(--quinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
}
.onboarding-page .onboarding-form .input-container .input-field:focus {
  border-color: #5095fc;
  outline: none;
}
.onboarding-page .onboarding-form.educational-form {
  max-width: 960px;
}
.onboarding-page .onboarding-form .onboarding-title {
  margin: 0 0 8px 0;
  font-family: "General Sans", sans-serif;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  background: linear-gradient(90deg, #4a8ff7 0%, #305996 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 12px;
}
.onboarding-page .onboarding-form .section-label {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--secondary-text-color);
  margin-bottom: 12px;
  display: block;
}
.onboarding-page .onboarding-form .section-label .required {
  color: var(--accent-primary-red-color);
}
.onboarding-page .onboarding-form .form-row-1 {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  position: relative;
  z-index: 101;
  margin-bottom: 0;
}
@media (min-width: 1601px) {
  .onboarding-page .onboarding-form .form-row-1 {
    flex-wrap: nowrap;
  }
}
@media (min-width: 901px) and (max-width: 1600px) {
  .onboarding-page .onboarding-form .form-row-1 {
    flex-wrap: wrap;
  }
  .onboarding-page .onboarding-form .form-row-1 > * {
    flex: 1 1 calc(50% - 8px);
    min-width: calc(50% - 8px);
  }
}
@media (min-width: 651px) and (max-width: 900px) {
  .onboarding-page .onboarding-form .form-row-1 {
    flex-wrap: wrap;
  }
}
@media (max-width: 650px) {
  .onboarding-page .onboarding-form .form-row-1 {
    flex-direction: column;
    flex-wrap: nowrap;
  }
}
@media (min-width: 651px) and (max-width: 900px) {
  .onboarding-page .onboarding-form .form-row-1 > * {
    flex: 1 1 calc(50% - 8px);
    min-width: calc(50% - 8px);
  }
}
@media (max-width: 650px) {
  .onboarding-page .onboarding-form .form-row-1 > * {
    flex: 1 1 100%;
    min-width: 100%;
  }
}
.onboarding-page .onboarding-form .form-row-phone {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .form-row-phone > * {
  flex: 1 1 calc(50% - 8px);
  min-width: calc(50% - 8px);
}
.onboarding-page .onboarding-form .form-row-phone .whatsapp-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: auto;
  min-height: 105px;
}
.onboarding-page .onboarding-form .form-row-phone .whatsapp-input-wrapper .input-container {
  margin-bottom: 0;
  white-space: nowrap;
}
.onboarding-page .onboarding-form .form-row-phone .whatsapp-input-wrapper .checkbox-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 0;
}
.onboarding-page .onboarding-form .form-row-phone .whatsapp-input-wrapper .checkbox-container input {
  width: 24px !important;
  height: 16px;
  cursor: pointer;
}
.onboarding-page .onboarding-form .form-row-phone .whatsapp-input-wrapper .checkbox-container label {
  font-family: "General Sans", sans-serif;
  font-size: 14px;
  line-height: 1.25;
  color: #333b48;
  cursor: pointer;
}
.onboarding-page .onboarding-form .form-row-2 {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  z-index: 101;
  margin-bottom: 0;
}
@media (max-width: 900px) {
  .onboarding-page .onboarding-form .form-row-2 {
    flex-direction: column;
    gap: 24px;
  }
}
@media (min-width: 901px) {
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper {
    width: 450px !important;
  }
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper .input-container .input-label {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    color: var(--secondary-text-color);
    margin-bottom: 0;
  }
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper .input-container .input-field {
    height: 60px;
    width: 100%;
    margin-bottom: 15px;
  }
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper .checkbox-container {
    display: flex;
    gap: 12px;
  }
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper .checkbox-container input {
    width: 24px !important;
  }
}
@media (min-width: 651px) and (max-width: 900px) {
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper {
    width: 100% !important;
    flex: 1 1 100% !important;
    max-width: 100% !important;
  }
}
.onboarding-page .onboarding-form .form-row-2 .gender-section {
  width: 506px;
  max-width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 101;
}
@media (max-width: 900px) {
  .onboarding-page .onboarding-form .form-row-2 .gender-section {
    width: 100%;
  }
}
.onboarding-page .onboarding-form .form-row-2 .gender-section .gender-options {
  display: flex;
  gap: 10px;
}
.onboarding-page .onboarding-form .form-row-2 .gender-section .gender-options .gender-option {
  flex: 1 1 auto;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
  color: var(--quinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.onboarding-page .onboarding-form .form-row-2 .gender-section .gender-options .gender-option:hover {
  border-color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .form-row-2 .gender-section .gender-options .gender-option.selected {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .form-row-2 .dob-section {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .form-row-2 .dob-section .dob-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .form-row-2 .dob-section .dob-inputs .dob-input {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  text-align: left;
  height: 60px;
  transition: all 0.2s ease;
  max-width: 80px;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .form-row-2 .dob-section .dob-inputs .dob-input:focus {
  outline: none;
  border-color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .form-row-2 .dob-section .dob-inputs .dob-input::placeholder {
  color: var(--quinary-text-color);
}
.onboarding-page .onboarding-form .form-row-2 .dob-section .dob-inputs .dob-separator {
  color: var(--quinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
}
.onboarding-page .onboarding-form .social-profiles-section {
  margin-top: 32px;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .social-profiles-section .section-title {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--secondary-text-color);
  margin-bottom: 16px;
}
.onboarding-page .onboarding-form .social-profiles-section .social-profiles-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .social-profiles-section .social-profiles-row > * {
  flex: 1 1 calc(50% - 8px);
  min-width: calc(50% - 8px);
}
@media (max-width: 650px) {
  .onboarding-page .onboarding-form .social-profiles-section .social-profiles-row > * {
    flex: 1 1 100%;
    min-width: 100%;
  }
}
.onboarding-page .onboarding-form .checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.onboarding-page .onboarding-form .checkbox-container input {
  width: 24px !important;
  height: 16px;
  cursor: pointer;
}
.onboarding-page .onboarding-form .address-section-wrapper {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  z-index: 101;
  margin-bottom: 0;
}
@media (max-width: 900px) {
  .onboarding-page .onboarding-form .address-section-wrapper {
    width: 100%;
  }
}
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row > * {
  flex: 1 1 0;
  min-width: 0;
  position: relative;
  z-index: 101;
}
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row .pincode-input-wrapper {
  flex: 1 1 0;
  min-width: 0;
  position: relative;
}
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row .pincode-input-wrapper .input-container,
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row .pincode-input-wrapper > div {
  width: 100%;
}
.onboarding-page .onboarding-form .address-section-wrapper .address-fields-row .pincode-input-wrapper .pincode-loading-indicator {
  display: block;
  font-size: 12px;
  color: #5095fc;
  margin-top: 4px;
  font-family: "General Sans", sans-serif;
}
.onboarding-page .onboarding-form .form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .onboarding-page .onboarding-form .form-grid {
    grid-template-columns: 1fr;
  }
}
.onboarding-page .onboarding-form .form-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-bottom: 32px;
}
.onboarding-page .onboarding-form .form-grid-2 .input-container {
  width: 100%;
}
@media (max-width: 1350px) {
  .onboarding-page .onboarding-form .form-grid-2 {
    gap: 24px;
  }
}
@media (max-width: 900px) {
  .onboarding-page .onboarding-form .form-grid-2 {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
.onboarding-page .onboarding-form .postgraduate-question-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}
.onboarding-page .onboarding-form .postgraduate-question-section .postgraduate-question-label {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: #444f5f;
  margin-bottom: 0;
}
.onboarding-page .onboarding-form .postgraduate-question-section .postgraduate-options {
  display: flex;
  gap: 10px;
}
.onboarding-page .onboarding-form .postgraduate-question-section .postgraduate-options .postgraduate-option-btn {
  flex: 1 0 0;
  height: 60px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #d8e3f4;
  background: white;
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  color: #94a0b3;
  cursor: pointer;
  transition: all 0.3s ease;
}
.onboarding-page .onboarding-form .postgraduate-question-section .postgraduate-options .postgraduate-option-btn:hover {
  border-color: var(--accent-primary-blue-color);
  color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .postgraduate-question-section .postgraduate-options .postgraduate-option-btn.active {
  background: #5095fc;
  border-color: #5095fc;
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .form-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}
@media (max-width: 1024px) {
  .onboarding-page .onboarding-form .form-grid-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .onboarding-page .onboarding-form .form-grid-3 {
    grid-template-columns: 1fr;
  }
}
.onboarding-page .onboarding-form .form-grid-1 {
  margin-bottom: 32px;
}
.onboarding-page .onboarding-form .input-with-checkbox .checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.onboarding-page .onboarding-form .input-with-checkbox .checkbox-container input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.onboarding-page .onboarding-form .input-with-checkbox .checkbox-container label {
  color: var(--secondary-text-color);
  font-family: "General-sans";
  font-size: 14px;
  cursor: pointer;
}
.onboarding-page .onboarding-form .education-level-section {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.onboarding-page .onboarding-form .education-level-section .education-level-options {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}
.onboarding-page .onboarding-form .education-level-section .education-level-options .education-option {
  flex: 1 1 auto;
  min-width: 140px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #d8e3f4;
  background: white;
  color: #94a0b3;
  font-family: "Medium Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 900px) {
  .onboarding-page .onboarding-form .education-level-section .education-level-options .education-option {
    flex: 1 1 calc(50% - 5px);
    min-width: calc(50% - 5px);
    font-size: 14px;
    padding: 12px 8px;
  }
}
.onboarding-page .onboarding-form .education-level-section .education-level-options .education-option:hover {
  border-color: #5095fc;
}
.onboarding-page .onboarding-form .education-level-section .education-level-options .education-option.selected {
  background: #5095fc;
  border-color: #5095fc;
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .work-experience-radio-section {
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--quartinary-surface-color);
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button {
  padding: 14px 24px;
  border-radius: 8px;
  border: 2px solid var(--quartinary-surface-color);
  background: white;
  color: var(--secondary-text-color);
  font-family: "Semi Sans";
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button:hover {
  border-color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button.selected {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button.selected .radio-circle {
  border-color: white;
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button.selected .radio-circle .radio-dot {
  background: var(--primary-surface-color);
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button {
  display: flex;
  align-items: center;
  gap: 10px;
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button .radio-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--quartinary-surface-color);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.onboarding-page .onboarding-form .work-experience-radio-section .radio-options .radio-button .radio-circle .radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .address-section {
  margin-bottom: 32px;
}
.onboarding-page .onboarding-form .ctc-input-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .section-label {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: #444f5f;
  margin-bottom: 8px;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .section-label .required {
  color: #ef5054;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .form-row-experience {
  display: flex;
  gap: 16px;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .form-row-experience .input-container .input-label {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--secondary-text-color);
  margin-bottom: 0;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .form-row-experience .input-container .select-field {
  height: 60px;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container {
  display: flex;
  align-items: center;
  height: 60px;
  border-radius: 8px;
  border: 1px solid #d8e3f4;
  background: white;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container:focus-within {
  border-color: #5095fc;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container:has(.ctc-input-field:disabled) {
  background: #f5f5f5;
  border-color: #e0e0e0;
  opacity: 0.6;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container:has(.ctc-input-field:disabled) .ctc-prefix {
  background: #e0e0e0;
  color: #94a0b3;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container:has(.ctc-input-field:disabled) .ctc-suffix {
  color: #94a0b3;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container .ctc-prefix {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 35px;
  padding: 16px 8px;
  border-right: 1px solid #d8e3f4;
  border-radius: 8px 0 0 8px;
  background: #d8e3f4;
  font-family: "General Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #444f5f;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container .ctc-input-field {
  flex: 1;
  height: 100%;
  padding: 16px;
  border: none;
  background: transparent;
  font-family: "General Sans", sans-serif;
  font-size: 14px;
  line-height: 1.25;
  color: #333b48;
  outline: none;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container .ctc-input-field:disabled {
  background-color: #f5f5f5;
  color: #94a0b3;
  cursor: not-allowed;
  opacity: 0.6;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container .ctc-input-field::placeholder {
  color: #94a0b3;
  font-size: 14px;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-input-container .ctc-suffix {
  padding: 16px;
  font-family: "General Sans", sans-serif;
  font-size: 14px;
  color: #94a0b3;
}
.onboarding-page .onboarding-form .ctc-input-wrapper .ctc-hint {
  margin-top: 8px;
  margin: 0;
  font-family: "General Sans", sans-serif;
  font-size: 16px;
  line-height: 1.25;
  color: #444f5f;
}
.onboarding-page .onboarding-form .employment-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.onboarding-page .onboarding-form .employment-section .section-label {
  font-family: "Semi Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--secondary-text-color);
  margin-bottom: 0;
}
.onboarding-page .onboarding-form .employment-section .section-label .required {
  color: var(--accent-primary-red-color);
  margin-left: 4px;
}
.onboarding-page .onboarding-form .employment-section .employment-options {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option {
  flex: 1;
  min-width: 150px;
  max-width: 300px;
  height: 60px;
  padding: 16px 24px;
  border-radius: 8px;
  border: 2px solid var(--quartinary-surface-color);
  background: var(--primary-surface-color);
  color: var(--secondary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option .check-icon {
  display: none;
  font-size: 18px;
  font-weight: 600;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option .option-label {
  flex: 1;
  text-align: center;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option:hover {
  border-color: var(--accent-primary-blue-color);
  background: var(--accent-quartinary-blue-color);
  color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option.selected {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
  box-shadow: 0 2px 8px rgba(80, 149, 252, 0.2);
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option.selected .check-icon {
  display: inline-block;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option.selected .option-label {
  font-weight: 600;
}
.onboarding-page .onboarding-form .employment-section .employment-options .employment-option.selected:hover {
  background: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .employment-status-section,
.onboarding-page .onboarding-form .postgraduate-question {
  margin-bottom: 32px;
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options {
  display: flex;
  gap: 16px;
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options .option-button,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options .option-button {
  flex: 1;
  max-width: 300px;
  padding: 16px 32px;
  border-radius: 8px;
  border: 2px solid var(--quartinary-surface-color);
  background: white;
  color: var(--secondary-text-color);
  font-family: "Semi Sans";
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options .option-button .checkmark,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options .option-button .checkmark {
  display: none;
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options .option-button:hover,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options .option-button:hover {
  border-color: var(--accent-primary-blue-color);
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options .option-button.selected,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options .option-button.selected {
  background: var(--accent-primary-blue-color);
  border-color: var(--accent-primary-blue-color);
  color: var(--main-surface-color);
}
.onboarding-page .onboarding-form .employment-status-section .yes-no-options .option-button.selected .checkmark,
.onboarding-page .onboarding-form .postgraduate-question .yes-no-options .option-button.selected .checkmark {
  display: inline-block;
}
.onboarding-page .onboarding-form .postgraduate-fields {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 2px solid var(--quartinary-surface-color);
}
.onboarding-page .onboarding-form .postgraduate-fields .subsection-title {
  color: var(--primary-text-color);
  font-family: "Semi Sans";
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
}
.onboarding-page .onboarding-form .input-with-prefix {
  position: relative;
}
.onboarding-page .onboarding-form .input-with-prefix .input-prefix {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--secondary-text-color);
  font-family: "General-sans";
  font-size: 16px;
  font-weight: 600;
  pointer-events: none;
}
.onboarding-page .onboarding-form .input-with-prefix .input-suffix {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--secondary-text-color);
  font-family: "General-sans";
  font-size: 14px;
  pointer-events: none;
}
.onboarding-page .onboarding-form .input-with-prefix .input-hint {
  margin-top: 8px;
  color: var(--secondary-text-color);
  font-family: "General-sans";
  font-size: 13px;
}
.onboarding-page .onboarding-form .input-with-prefix input {
  padding-left: 40px !important;
  padding-right: 60px !important;
}
.onboarding-page .onboarding-form .subsection-title {
  color: var(--accent-primary-blue-color);
  font-family: "Semi Sans";
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
}
.onboarding-page .onboarding-form .work-experience-fields-section {
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--quartinary-surface-color);
}
.onboarding-page .onboarding-form .resume-section-divider {
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--quartinary-surface-color);
}
.onboarding-page .onboarding-form .social-section-divider {
  margin-bottom: 40px;
}
.onboarding-page .onboarding-form .form-actions {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #E5EBF4;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.onboarding-page .onboarding-form .form-actions .back-button {
  background: transparent;
  color: var(--accent-primary-blue-color);
  font-family: "Semi Sans";
  font-size: 18px;
  font-weight: 600;
  padding: 16px 48px;
  border-radius: 12px;
  border: 2px solid var(--accent-primary-blue-color);
  cursor: pointer;
  transition: all 0.3s ease;
}
.onboarding-page .onboarding-form .form-actions .back-button:hover {
  background: var(--accent-quartinary-blue-color);
}
.onboarding-page .onboarding-form .form-actions .submit-button {
  position: relative;
  background: var(--accent-primary-blue-color);
  color: white;
  font-family: "Semi Sans";
  font-size: 18px;
  font-weight: 600;
  padding: 16px 48px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: visible;
  z-index: 1;
  box-shadow: 0 0 0 1px rgba(215, 231, 254, 0.7), 0 0 0 2px rgba(230, 242, 255, 0.5), 0 0 0 3px rgba(240, 247, 255, 0.3), 0 4px 12px rgba(80, 149, 252, 0.3);
}
.onboarding-page .onboarding-form .form-actions .submit-button::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(215, 231, 254, 0.9) 0%, rgba(200, 220, 250, 0.95) 100%);
  z-index: -1;
}
.onboarding-page .onboarding-form .form-actions .submit-button::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(230, 242, 255, 0.7) 0%, rgba(215, 231, 254, 0.8) 100%);
  z-index: -2;
}
.onboarding-page .onboarding-form .form-actions .submit-button:hover {
  background: #3d7de0;
  transform: translateY(-2px);
  box-shadow: 0 0 0 1px rgba(215, 231, 254, 0.8), 0 0 0 2px rgba(230, 242, 255, 0.6), 0 0 0 3px rgba(240, 247, 255, 0.4), 0 8px 16px rgba(80, 149, 252, 0.4);
}
.onboarding-page .onboarding-form .form-actions .submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.onboarding-page .onboarding-form .error-message {
  color: var(--accent-primary-red-color);
  font-family: "General-sans";
  font-size: 13px;
  margin-top: 6px;
  display: block;
}
.onboarding-page .onboarding-form .error-message.section-error {
  margin-bottom: 16px;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 500;
}
.onboarding-page .onboarding-form .section-heading {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.input-field-onboarding {
  flex: 1 1 0;
  min-width: 0;
}
@media (max-width: 1199px) {
  .input-field-onboarding {
    flex: 1 1 calc(50% - 8px);
    min-width: calc(50% - 8px);
  }
}

.form-row-organization .input-field {
  height: 60px;
}

@media (max-width: 1199px) {
  .onboarding-page .layered-background-new {
    display: none !important;
  }
}
@media (max-width: 1199px) {
  .onboarding-page .submit-button-figma-new {
    position: fixed !important;
    bottom: 20px !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    width: calc(100% - 80px) !important;
    max-width: 400px !important;
    padding: 16px 24px !important;
    font-size: 18px !important;
  }
}
@media (max-width: 768px) {
  .onboarding-page .submit-button-figma-new {
    width: calc(100% - 40px) !important;
  }
}
@media (max-width: 1350px) {
  .onboarding-page .onboarding-form .form-row-1 {
    flex-wrap: wrap;
  }
  .onboarding-page .onboarding-form .form-row-1 > * {
    flex: 1 1 calc(50% - 8px);
    min-width: calc(50% - 8px);
  }
}
@media (max-width: 1199px) {
  .onboarding-page .onboarding-form .form-row-2 {
    flex-direction: column;
    gap: 24px;
  }
  .onboarding-page .onboarding-form .form-row-2 .whatsapp-field-wrapper {
    width: 100% !important;
    flex: 1 1 100% !important;
    max-width: 100% !important;
  }
  .onboarding-page .onboarding-form .form-row-2 .gender-section {
    width: 100%;
  }
  .onboarding-page .onboarding-form .form-row-2 .dob-section {
    width: 100%;
  }
}
@media (max-width: 1199px) {
  .onboarding-page .onboarding-form .address-section-wrapper {
    width: 100%;
  }
}
@media (max-width: 1199px) {
  .onboarding-page .onboarding-form .ctc-input-wrapper {
    flex-direction: column;
  }
}

@media (max-width: 1199px) {
  .onboarding-welcome-page {
    background: linear-gradient(to bottom, #ffffff 0%, #d7e7fe 101.45%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
  }
  .onboarding-welcome-page .layered-background-new {
    display: none !important;
  }
  .onboarding-welcome-page .welcome-logo {
    position: absolute;
    left: auto;
    right: 20px;
    top: 20px;
    width: 100px;
    height: auto;
  }
  .onboarding-welcome-page .welcome-start-button {
    position: relative;
    bottom: auto;
    right: auto;
    transform: none;
    display: block;
    width: 100%;
    max-width: 448px;
    height: 56px;
    padding: 16px 32px;
    font-size: 18px;
    border-radius: 8px;
    background: #5095fc;
    color: #fcfcfc;
    font-family: "General Sans", sans-serif;
    font-weight: 600;
    line-height: 1.4;
    border: none;
    cursor: pointer;
    margin-top: 16px;
    order: 3;
    box-shadow: 0 0 20px rgba(80, 149, 252, 0.4), 0 4px 12px rgba(80, 149, 252, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .onboarding-welcome-page .welcome-start-button:hover:not(:disabled) {
    transform: translateY(-2px);
  }
  .onboarding-welcome-page .welcome-start-button:active:not(:disabled) {
    transform: translateY(0);
  }
  .onboarding-welcome-page .welcome-start-button:disabled {
    transform: none;
  }
  .onboarding-welcome-page .welcome-greeting {
    position: relative;
    left: auto;
    top: auto;
    font-size: 34px;
    text-align: center;
    width: 100%;
    max-width: 448px;
    margin: 0 0 24px 0;
    font-family: "General Sans", sans-serif;
    font-weight: 600;
    color: #333b48;
    order: 1;
  }
  .onboarding-welcome-page .welcome-content-section {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    width: 100%;
    max-width: 448px;
    gap: 24px;
    margin: 0;
    order: 2;
  }
  .onboarding-welcome-page .welcome-content-section .welcome-title {
    font-size: 32px;
    width: 100%;
    font-family: "General Sans", sans-serif;
    font-weight: 600;
    line-height: 1.2;
    background: linear-gradient(to right, #4a8ff7, #305996);
    background-clip: text;
  }
  .onboarding-welcome-page .welcome-content-section .welcome-description {
    font-size: 20px;
    width: 100%;
    max-width: 100%;
    color: #5d6c83;
    font-family: "General Sans", sans-serif;
    font-weight: 500;
    margin: 0;
  }
}

.review-screen-container {
  min-height: 120vh;
  position: relative;
  padding: 0;
  width: 100%;
  overflow-y: auto;
}

.review-screen-header {
  position: absolute;
  left: 60px;
  top: 60px;
  width: 1320px;
  max-width: calc(100% - 120px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
}

.review-screen-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.review-screen-title {
  font-family: "Arial", sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  color: #101828;
  margin: 0;
}

.review-back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}
.review-back-button .material-symbols-outlined {
  font-size: 24px;
  color: #101828;
}
.review-back-button:hover {
  opacity: 0.7;
}

.review-screen-logo {
  height: 32px;
  width: 130px;
}
.review-screen-logo img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.review-screen-content {
  position: absolute;
  left: 60px;
  top: 136px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 900px;
  max-width: calc(100% - 120px);
  z-index: 1;
}

.review-section-card {
  background: white;
  border: 0.6px solid #7c8ba2;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.review-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
}

.review-section-title {
  font-family: "General Sans", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #101828;
  margin: 0;
}

.review-edit-button {
  display: flex;
  align-items: center;
  gap: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  height: 20px;
  width: 48.406px;
  position: relative;
}
.review-edit-button .material-symbols-outlined {
  font-size: 16px;
  color: #0e6dfb;
  position: absolute;
  left: 0;
  top: 2px;
}
.review-edit-button span:last-child {
  font-family: "General Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #0e6dfb;
  position: absolute;
  left: 36.5px;
  top: -1.33px;
}
.review-edit-button:hover {
  opacity: 0.7;
}

.review-section-content {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  position: relative;
  width: 100%;
  row-gap: 16px;
  column-gap: 0;
}

.review-detail-item {
  display: flex;
  flex-direction: column;
  width: calc(50% - 0px);
  flex: 0 0 calc(50% - 0px);
  padding-right: 16px;
  box-sizing: border-box;
}
.review-detail-item.review-detail-item-full {
  width: 100%;
  flex: 1 1 100%;
  padding-right: 0;
  padding-left: 0;
}
.review-detail-item.review-detail-item-full:nth-child(even) {
  padding-left: 0;
}

.review-detail-label {
  font-family: "General Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #444f5f;
}

.review-detail-value {
  font-family: "General Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #0e6dfb;
}

.review-screen-footer {
  position: absolute;
  left: calc(87.5% + 8.5px);
  top: calc(50% + 905px);
  transform: translate(-50%, -50%);
  z-index: 10;
}

@media (max-width: 1199px) {
  .review-screen-container .layered-background-new {
    display: none !important;
  }
}
@media (max-width: 1199px) {
  .review-screen-container .submit-button-figma-new {
    position: fixed !important;
    bottom: 20px !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    width: calc(100% - 80px) !important;
    max-width: 400px !important;
    padding: 16px 24px !important;
    font-size: 18px !important;
  }
}
@media (max-width: 768px) {
  .review-screen-container .submit-button-figma-new {
    width: calc(100% - 40px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/components/Onboarding/onboarding.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACAF;ADGA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;ADKA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACJF;AApBA;;EAEE,2BAAA;EACA,6BAAA;AAsBF;;AAnBA;EACE,iBAAA;EACA,0GAAA;EACA,kBAAA;EACA,gBAAA;AAsBF;AApBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAsBJ;AApBI;EACE,YAAA;AAsBN;;AAhBA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAmBF;AAbE;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AAeJ;AAbI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAeN;AAVE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAYJ;AAVI;EACE,iCAAA;AAYN;AATI;EACE,oCAAA;EACA,gCAAA;AAWN;AANE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;AAQJ;AANI;EACE,SAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,8CAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAQN;AANM;EACE,cAAA;AAQR;AAJI;EACE,SAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;AAMN;AACE;EACE,mBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,8GACE;EAGF,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;AAFJ;AAMI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kFAAA;EACA,oBAAA;EACA,UAAA;AAJN;AAOI;EACE,+CAAA;EACA,+GACE;EAGF,6BAAA;AARN;AAWI;EACE,4CAAA;EACA,gFACE;EAEF,yBAAA;AAXN;AAcI;EACE,YAAA;EACA,mBAAA;EACA,8BAAA;AAZN;AAeI;EACE,0CAAA;EACA,mBAAA;AAbN;;AAiBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;AAdF;AAgBE;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AAdJ;AAiBI;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,iEAAA;EACA,4CAAA;AAfN;AAmBI;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iEAAA;EACA,6CAAA;AAjBN;AAqBI;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iEAAA;EACA,6CAAA;AAnBN;AAuBI;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iEAAA;EACA,6CAAA;AArBN;AAyBI;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iEAAA;EACA,4CAAA;AAvBN;;AA4BE;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,8GACE;EAGF,yCAAA;AA5BJ;AA8BI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,kFAAA;EACA,oBAAA;EACA,UAAA;AA5BN;AA+BI;EACE,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AA7BN;AAgCI;EACE,+CAAA;EACA,+GACE;EAGF,6BAAA;AAjCN;AAoCI;EACE,4CAAA;EACA,gFACE;EAEF,yBAAA;AApCN;AAuCI;EACE,0CAAA;EACA,mBAAA;AArCN;ACnKE;EDiIA;IA4EI,eAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;IACA,2BAAA;IACA,wBAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;EAtCJ;EAwCI;IACE,2BAAA;EAtCN;EAwCI;IACE,4CAAA;EAtCN;EAwCI;IACE,yCAAA;EAtCN;AACF;ACvKE;ED+GA;IAkGI,wBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EAtCJ;AACF;;AAyCA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAtCF;AA4CE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AA1CJ;AA6CE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AA3CJ;AA6CI;EACE,kBAAA;EACA,sDAAA;AA3CN;AA6CM;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,uFAAA;AA3CR;AA8CM;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,uFAAA;AA5CR;AA+CM;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,uFAAA;AA7CR;AAgDM;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AA9CR;AAkDM;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uFAAA;AAhDR;AAqDE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAnDJ;AC7RE;EDsUA;IAaI,UAAA;IACA,4BAAA;EAlDJ;AACF;ACjRE;EDoTA;IAiBI,UAAA;IACA,SAAA;IACA,4BAAA;IACA,gBAAA;EAhDJ;AACF;AAkDI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAhDN;AAkDM;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAhDR;AAkDQ;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,2CAAA;EACA,UAAA;AAhDV;AAmDU;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kCAAA;EACA,4CAAA;EACA,2BAAA;AAjDZ;AAqDM;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,2CAAA;EACA,qCAAA;EACA,gCAAA;EACF,aAAA;EACA,mBAAA;EACA,uBAAA;EACE,oCAAA;EACA,eAAA;EACF,gBAAA;EACE,gBAAA;EACA,UAAA;EACF,yBAAA;AAnDR;AAqDQ;EACI,4CAAA;EACA,8CAAA;EACA,gCAAA;EACA,gBAAA;AAnDZ;AAsDQ;EACI,4CAAA;EACA,8CAAA;EACF,gCAAA;EACE,gBAAA;AApDZ;AA0DI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAxDN;AA0DM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAxDR;AA+DE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AA7DJ;ACnYE;EDobA;IAgBI,yBAAA;IACA,eAAA;IACA,UAAA;IACA,UAAA;IACA,oBAAA;IACA,qBAAA;EA7DJ;AACF;AC3XE;EDkaA;IAwBI,wBAAA;IACA,UAAA;IACA,SAAA;IACA,SAAA;IACA,qBAAA;IACA,gBAAA;EA3DJ;AACF;AA6DI;EACE,aAAA;AA3DN;AA4DM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA1DR;AA+DI;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AA7DN;AA+DM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AA7DR;AA8DQ;EACE,sCAAA;AA5DV;AAgEM;EACE,YAAA;AA9DR;AAiEM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;AA/DR;AAiEQ;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;AA/DV;AAkEQ;EACE,gCAAA;EACA,sCAAA;EACA,eAAA;AAhEV;AAmEQ;EACE,qBAAA;EACA,aAAA;AAjEV;AAsEI;EAGE,gBAAA;AAtEN;AAyEI;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvEN;AA0EI;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;AAxEN;AA0EM;EACE,sCAAA;AAxER;AA4EI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AA1EN;AA6EM;EATF;IAUI,iBAAA;EA1EN;AACF;AA6EM;EAdF;IAeI,eAAA;EA1EN;EA2EM;IACE,yBAAA;IACA,0BAAA;EAzER;AACF;AA6EM;EAvBF;IAwBI,eAAA;EA1EN;AACF;AA6EM;EA5BF;IA6BI,sBAAA;IACA,iBAAA;EA1EN;AACF;AA8EQ;EAFF;IAGI,yBAAA;IACA,0BAAA;EA3ER;AACF;AA6EQ;EAPF;IAQI,cAAA;IACA,eAAA;EA1ER;AACF;AA+EI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA7EN;AA+EM;EACE,yBAAA;EACA,0BAAA;AA7ER;AAgFM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;AA9ER;AAgFQ;EACE,gBAAA;EACA,mBAAA;AA9EV;AAmFQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAjFV;AAmFU;EACE,sBAAA;EACA,YAAA;EACA,eAAA;AAjFZ;AAoFU;EACE,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAlFZ;AAwFI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAtFN;AC/mBE;ED8rBE;IAUI,sBAAA;IACA,SAAA;EArFN;AACF;AAyFQ;EAFF;IAGI,uBAAA;EAtFR;EAwFU;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,gBAAA;EAtFZ;EAwFU;IACE,YAAA;IACA,WAAA;IACA,mBAAA;EAtFZ;EAyFQ;IACE,aAAA;IACA,SAAA;EAvFV;EAwFU;IACE,sBAAA;EAtFZ;AACF;AA4FQ;EA7BF;IA8BI,sBAAA;IACA,yBAAA;IACA,0BAAA;EAzFR;AACF;AA6FM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AA3FR;AChqBE;EDivBI;IAaI,WAAA;EA1FR;AACF;AA4FQ;EACE,aAAA;EACA,SAAA;AA1FV;AA6FU;EACE,cAAA;EAEA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,wCAAA;EACA,gCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA5FZ;AA8FY;EACE,8CAAA;AA5Fd;AA+FY;EACE,4CAAA;EACA,8CAAA;EACA,gCAAA;AA7Fd;AAmGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAjGR;AAmGQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAjGV;AAmGU;EACE,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAjGZ;AAmGY;EACE,aAAA;EACA,8CAAA;AAjGd;AAoGY;EACE,gCAAA;AAlGd;AAsGU;EACE,gCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;AApGZ;AA0GI;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;AAxGN;AA0GM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;AAxGR;AA2GM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAzGR;AA2GQ;EACE,yBAAA;EACA,0BAAA;AAzGV;AA2GU;EAJF;IAKI,cAAA;IACA,eAAA;EAxGV;AACF;AA6GQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3GV;AA4GU;EACE,sBAAA;EACA,YAAA;EACA,eAAA;AA1GZ;AA6GI;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AA3GN;ACnyBE;EDs4BE;IAWI,WAAA;EA1GN;AACF;AA4GM;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA1GR;AA4GQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA1GV;AA6GQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA3GV;AA6GU;;EAEE,WAAA;AA3GZ;AA8GU;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AA5GZ;AAkHI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAhHN;AC30BE;EDu7BE;IAOI,0BAAA;EA/GN;AACF;AAoHI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAlHN;AAmHQ;EACE,WAAA;AAjHV;AC7zBE;EDw6BE;IASI,SAAA;EAhHN;AACF;AC91BE;EDo8BE;IAYI,0BAAA;IACA,SAAA;EA9GN;AACF;AAiHI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA/GN;AAiHM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA/GR;AAkHM;EACE,aAAA;EACA,SAAA;AAhHR;AAkHQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAhHV;AAkHU;EACE,8CAAA;EACA,uCAAA;AAhHZ;AAmHU;EACE,mBAAA;EACA,qBAAA;EACA,gCAAA;AAjHZ;AAuHI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AArHN;ACn5BE;EDogCE;IAOI,qCAAA;EApHN;AACF;ACx5BE;EDogCE;IAUI,0BAAA;EAlHN;AACF;AAqHI;EACE,mBAAA;AAnHN;AAwHM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAtHR;AAwHQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAtHV;AAyHQ;EACE,kCAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAvHV;AA4HI;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA1HN;AA4HM;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AA1HR;AA4HQ;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1HV;ACr9BE;ED2jCM;IAuBI,yBAAA;IACA,0BAAA;IACA,eAAA;IACA,iBAAA;EAzHV;AACF;AA2HU;EACE,qBAAA;AAzHZ;AA4HU;EACE,mBAAA;EACA,qBAAA;EACA,gCAAA;AA1HZ;AAgII;EACE,mBAAA;EACA,oBAAA;EACA,wDAAA;AA9HN;AAgIM;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA9HR;AAgIQ;EACE,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,iBAAA;EACA,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9HV;AAgIU;EACE,8CAAA;AA9HZ;AAiIU;EACE,4CAAA;EACA,8CAAA;EACA,gCAAA;AA/HZ;AAiIY;EACE,mBAAA;AA/Hd;AAiIc;EACE,wCAAA;AA/HhB;AAqIQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAnIV;AAqIU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAnIZ;AAqIY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;AAnId;AA2II;EACE,mBAAA;AAzIN;AA6II;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA3IN;AA6IM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA3IR;AA4IQ;EACE,cAAA;AA1IV;AA6IM;EACE,aAAA;EACA,SAAA;AA3IR;AA8IQ;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AA5IV;AA8IQ;EACE,YAAA;AA5IV;AAgJM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AA9IR;AA+IQ;EACE,qBAAA;AA7IV;AA+IQ;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;AA7IV;AA8IU;EACE,mBAAA;EACA,cAAA;AA5IZ;AA8IU;EACE,cAAA;AA5IZ;AA+IQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,0BAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7IV;AA+IQ;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AA7IV;AA+IU;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AA7IZ;AA+IU;EACE,cAAA;EACA,eAAA;AA7IZ;AAgJQ;EACE,aAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AA9IV;AAkJM;EACE,eAAA;EACA,SAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhJR;AAqJI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAnJN;AAqJM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAnJR;AAqJQ;EACE,sCAAA;EACA,gBAAA;AAnJV;AAuJM;EACE,aAAA;EACA,SAAA;EACA,eAAA;AArJR;AAuJQ;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,wCAAA;EACA,kCAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AArJV;AAuJU;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AArJZ;AAwJU;EACE,OAAA;EACA,kBAAA;AAtJZ;AAyJU;EACE,8CAAA;EACA,+CAAA;EACA,uCAAA;AAvJZ;AA0JU;EACE,4CAAA;EACA,8CAAA;EACA,gCAAA;EACA,6CAAA;AAxJZ;AA0JY;EACE,qBAAA;AAxJd;AA2JY;EACE,gBAAA;AAzJd;AA4JY;EACE,4CAAA;EACA,gCAAA;AA1Jd;AAiKI;;EAEE,mBAAA;AA/JN;AAiKM;;EACE,aAAA;EACA,SAAA;AA9JR;AAgKQ;;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,iBAAA;EACA,kCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA7JV;AA+JU;;EACE,aAAA;AA5JZ;AA+JU;;EACE,8CAAA;AA5JZ;AA+JU;;EACE,4CAAA;EACA,8CAAA;EACA,gCAAA;AA5JZ;AA8JY;;EACE,qBAAA;AA3Jd;AAkKI;EACE,gBAAA;EACA,iBAAA;EACA,qDAAA;AAhKN;AAkKM;EACE,gCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhKR;AAoKI;EACE,kBAAA;AAlKN;AAoKM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAlKR;AAqKM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;AAnKR;AAsKM;EACE,eAAA;EACA,kCAAA;EACA,2BAAA;EACA,eAAA;AApKR;AAuKM;EACE,6BAAA;EACA,8BAAA;AArKR;AAyKI;EACE,uCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvKN;AA0KI;EACE,mBAAA;EACA,oBAAA;EACA,wDAAA;AAxKN;AA2KI;EACE,mBAAA;EACA,oBAAA;EACA,wDAAA;AAzKN;AA4KI;EACE,mBAAA;AA1KN;AA8KI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AA5KN;AA8KM;EACE,uBAAA;EACA,uCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kDAAA;EACA,eAAA;EACA,yBAAA;AA5KR;AA8KQ;EACE,+CAAA;AA5KV;AAgLM;EACE,kBAAA;EACA,4CAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EA4BA,0JACE;AA1MV;AAgLQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gGAAA;EACA,WAAA;AA9KV;AAiLQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+FAAA;EACA,WAAA;AA/KV;AAyLQ;EACE,mBAAA;EACA,2BAAA;EACA,0JACE;AAxLZ;AA8LQ;EACE,YAAA;EACA,mBAAA;AA5LV;AAiMI;EACE,sCAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AA/LN;AAiMM;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/LR;AAmMI;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjMN;;AAqMA;EACE,WAAA;EACA,YAAA;AAlMF;ACj4CE;EDikDF;IAKI,yBAAA;IACA,0BAAA;EAjMF;AACF;;AAqME;EACE,YAAA;AAlMJ;;AC34CE;EDqlDA;IAEI,wBAAA;EAvMJ;AACF;ACj5CE;ED4lDA;IAEI,0BAAA;IACA,uBAAA;IACA,oBAAA;IACA,sBAAA;IACA,sCAAA;IACA,mCAAA;IACA,2BAAA;IACA,6BAAA;IACA,0BAAA;EAzMJ;AACF;AC54CE;ED0kDA;IAaI,mCAAA;EAvMJ;AACF;ACz6CE;EDqnDE;IAEI,eAAA;EA1MN;EA2MM;IACE,yBAAA;IACA,0BAAA;EAzMR;AACF;AC56CE;EDynDE;IAEI,sBAAA;IACA,SAAA;EA3MN;EA6MM;IACE,sBAAA;IACA,yBAAA;IACA,0BAAA;EA3MR;EA8MM;IACE,WAAA;EA5MR;EA+MM;IACE,WAAA;EA7MR;AACF;AC77CE;ED8oDE;IAEI,WAAA;EA/MN;AACF;ACl8CE;EDopDE;IAEI,sBAAA;EAhNN;AACF;;ACv8CE;ED+pDF;IAEI,mEAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,iBAAA;IACA,aAAA;EArNF;EAuNE;IACE,wBAAA;EArNJ;EAwNE;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;IACA,YAAA;EAtNJ;EAyNE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,uCAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,QAAA;IACA,8GACE;EAxNN;EA4NI;IACE,2BAAA;EA1NN;EA4NI;IACE,wBAAA;EA1NN;EA4NI;IACE,eAAA;EA1NN;EA8NE;IACE,kBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,uCAAA;IACA,gBAAA;IACA,cAAA;IACA,QAAA;EA5NJ;EA+NE;IACE,kBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;IACA,SAAA;IACA,SAAA;IACA,QAAA;EA7NJ;EA+NI;IACE,eAAA;IACA,WAAA;IACA,uCAAA;IACA,gBAAA;IACA,gBAAA;IACA,uDAAA;IACA,qBAAA;EA7NN;EAgOI;IACE,eAAA;IACA,WAAA;IACA,eAAA;IACA,cAAA;IACA,uCAAA;IACA,gBAAA;IACA,SAAA;EA9NN;AACF;;AAoOA;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAjOF;;AAoOA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AAjOF;;AAoOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjOF;;AAoOA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAjOF;;AAoOA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjOF;AAmOE;EACE,eAAA;EACA,cAAA;AAjOJ;AAoOE;EACE,YAAA;AAlOJ;;AAsOA;EACE,YAAA;EACA,YAAA;AAnOF;AAqOE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAnOJ;;AAuOA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;AApOF;;AAuOA;EACE,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApOF;;AAuOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AApOF;;AAuOA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AApOF;;AAuOA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AApOF;AAsOE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AApOJ;AAuOE;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AArOJ;AAwOE;EACE,YAAA;AAtOJ;;AA0OA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AAvOF;;AA0OA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAvOF;AAyOE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAvOJ;AA0OI;EACE,eAAA;AAxON;;AA6OA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1OF;;AA6OA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1OF;;AA6OA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,WAAA;AA1OF;;ACruDE;EDo9DA;IAEI,wBAAA;EA5OJ;AACF;AC3uDE;ED09DA;IAEI,0BAAA;IACA,uBAAA;IACA,oBAAA;IACA,sBAAA;IACA,sCAAA;IACA,mCAAA;IACA,2BAAA;IACA,6BAAA;IACA,0BAAA;EA7OJ;AACF;ACtuDE;EDw8DA;IAaI,mCAAA;EA3OJ;AACF","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import '../../styles/styles.scss';\n\n// Add overflow scroll to body when onboarding is active\nbody:has(.onboarding-container),\nbody:has(.onboarding-page) {\n  overflow: scroll !important;\n  overflow-x: hidden !important;\n}\n\n.onboarding-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--secondary-surface-color) 0%, var(--tertiary-surface-color) 100%);\n  position: relative;\n  overflow: hidden;\n\n  .onboarding-logo {\n    position: absolute;\n    top: 40px;\n    right: 60px;\n    z-index: 10;\n\n    img {\n      height: 40px;\n    }\n  }\n}\n\n// Welcome Page Styles\n.onboarding-welcome-page {\n  position: relative;\n  min-height: 100vh;\n  width: 100%;\n  background: var(--main-surface-color);\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  // Ensure new layered background is visible on welcome page\n\n\n  // Top Right Logo\n  .welcome-logo {\n    position: absolute;\n    height: 32px;\n    left: calc(83.33% + 50px);\n    top: 64px;\n    width: 130px;\n    z-index: 10;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n\n  // Welcome Greeting\n  .welcome-greeting {\n    position: absolute;\n    left: 60px;\n    top: 64px;\n    font-family: 'Medium Sans', sans-serif;\n    font-size: 40px;\n    line-height: 1.2;\n    margin: 0;\n    z-index: 10;\n\n    .welcome-text {\n      color: var(--tertiary-text-color);\n    }\n\n    .user-name {\n      font-family: 'Semi Sans', sans-serif;\n      color: var(--primary-text-color);\n    }\n  }\n\n  // Main Content Section\n  .welcome-content-section {\n    position: absolute;\n    left: 60px;\n    top: 449px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    align-items: flex-start;\n    z-index: 10;\n    padding-bottom: 40px;\n\n    .welcome-title {\n      margin: 0;\n      font-family: 'General Sans', sans-serif;\n      font-size: 64px;\n      font-weight: 600;\n      line-height: 1.2;\n      background: var(--home-page-elective-selector);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      display: flex;\n      flex-direction: column;\n      white-space: nowrap;\n\n      span {\n        display: block;\n      }\n    }\n\n    .welcome-description {\n      margin: 0;\n      font-family: 'Medium Sans', sans-serif;\n      font-size: 22px;\n      line-height: 1.4;\n      color: var(--tertiary-text-color);\n      max-width: 50%;\n\n    }\n  }\n\n\n  // CTA Button - Centered within layers (matching form button style)\n  .welcome-start-button {\n    white-space: nowrap;\n    position: fixed;\n    right: 240px; // Position relative to right edge, centered in layer area\n    bottom: 135px; // Position relative to bottom edge\n    transform: translate(50%, 50%); // Center the button\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 32px;\n    border-radius: 8px;\n    border: none;\n    background: rgb(80, 149, 252); // Solid vibrant blue matching form button\n    box-shadow: \n      0 0 20px rgba(80, 149, 252, 0.4), // Soft blue glow\n      0 4px 12px rgba(80, 149, 252, 0.3), // Outer glow\n      0 2px 4px rgba(0, 0, 0, 0.1); // Subtle depth shadow\n    font-family: 'Semi Sans', sans-serif;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0.3px;\n    color: #ffffff;\n    z-index: 1000; // Above layers\n \n\n    // Subtle inner highlight\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border-radius: 8px;\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);\n      pointer-events: none;\n      opacity: 1;\n    }\n\n    &:hover:not(:disabled) {\n      transform: translate(50%, 50%) translateY(-2px);\n      box-shadow: \n        0 0 25px rgba(80, 149, 252, 0.5), // Enhanced glow\n        0 6px 16px rgba(80, 149, 252, 0.35),\n        0 2px 4px rgba(0, 0, 0, 0.1);\n      background: rgb(90, 159, 262);\n    }\n\n    &:active:not(:disabled) {\n      transform: translate(50%, 50%) translateY(0);\n      box-shadow: \n        0 0 15px rgba(80, 149, 252, 0.3),\n        0 2px 6px rgba(80, 149, 252, 0.25);\n      transition: all 0.1s ease;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      transform: translate(50%, 50%);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(80, 149, 252, 0.5);\n      outline-offset: 4px;\n    }\n  }\n}\n.layered-background-new {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n  overflow: hidden; // Prevent layers from extending beyond container\n\n  .layer-new {\n    position: absolute;\n    pointer-events: none; // Ensure layers don't interfere with form interactions\n    filter: blur(1px); // Soft blur for glowing effect\n\n    // Outermost layer - very faint, almost translucent\n    &.layer-1-new {\n      height: 424px;\n      width: 698px;\n      right: -50px; // Extend slightly beyond viewport for natural edge\n      bottom: -50px;\n      opacity: 0.02; // Very faint\n      border-radius: 100px;\n      background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);\n      box-shadow: 0 0 40px rgba(80, 149, 252, 0.1);\n    }\n\n    // Second outermost layer\n    &.layer-2-new {\n      height: 344px;\n      width: 598px;\n      right: 20px;\n      bottom: 20px;\n      opacity: 0.04; // Faint\n      border-radius: 80px;\n      background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);\n      box-shadow: 0 0 30px rgba(80, 149, 252, 0.15);\n    }\n\n    // Middle layer\n    &.layer-3-new {\n      height: 264px;\n      width: 500px;\n      right: 40px;\n      bottom: 40px;\n      opacity: 0.08; // More visible\n      border-radius: 60px;\n      background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);\n      box-shadow: 0 0 20px rgba(80, 149, 252, 0.15);\n    }\n\n    // Inner layer - more discernible light blue\n    &.layer-4-new {\n      height: 184px;\n      width: 399px;\n      right: 60px;\n      bottom: 60px;\n      opacity: 0.12; // More visible light blue\n      border-radius: 40px;\n      background: linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);\n      box-shadow: 0 0 20px rgba(80, 149, 252, 0.25);\n    }\n\n    // Second inner layer - closer to button\n    &.layer-5-new {\n      height: 106px;\n      width: 298px;\n      right: 80px;\n      bottom: 80px;\n      opacity: 0.16; // More visible\n      border-radius: 20px;\n      background:  linear-gradient(302deg, #D8DCE3 -2.4%, #0067FF 98.5%);\n      box-shadow: 0 0 15px rgba(80, 149, 252, 0.3);\n    }\n\n  }\n}\n  .submit-button-figma-new {\n    position: fixed;\n    right: 225px;\n    bottom: 135px;\n    transform: translate(50%, 50%);\n    cursor: pointer;\n    min-width: 200px;\n    width: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px 32px;\n    border-radius: 8px;\n    border: none;\n    background: rgb(80, 149, 252);\n    font-family: 'Semi Sans', sans-serif;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0.3px;\n    color: #ffffff;\n    z-index: 1000;\n    pointer-events: auto;\n    white-space: nowrap;\n    box-shadow:\n      0 0 20px rgba(80, 149, 252, 0.4),\n      0 4px 12px rgba(80, 149, 252, 0.3),\n      0 2px 4px rgba(0, 0, 0, 0.1);\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border-radius: 8px;\n      background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, transparent 50%);\n      pointer-events: none;\n      opacity: 1;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      transform: translate(50%, 50%);\n      box-shadow: none;\n      min-width: 200px;\n      pointer-events: none;\n    }\n\n    &:hover:not(:disabled) {\n      transform: translate(50%, 50%) translateY(-2px);\n      box-shadow:\n        0 0 25px rgba(80, 149, 252, 0.5),\n        0 6px 16px rgba(80, 149, 252, 0.35),\n        0 2px 4px rgba(0, 0, 0, 0.1);\n      background: rgb(90, 159, 262);\n    }\n\n    &:active:not(:disabled) {\n      transform: translate(50%, 50%) translateY(0);\n      box-shadow:\n        0 0 15px rgba(80, 149, 252, 0.3),\n        0 2px 6px rgba(80, 149, 252, 0.25);\n      transition: all 0.1s ease;\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(80, 149, 252, 0.5);\n      outline-offset: 4px;\n    }\n\n    // When screen is too narrow for side-by-side layout, move CTA to bottom center\n    @include m_desktop {\n      position: fixed;\n      right: auto;\n      bottom: 20px;\n      left: 50%;\n      transform: translateX(-50%);\n      width: calc(100% - 80px);\n      max-width: 400px;\n      padding: 16px 24px;\n      font-size: 18px;\n\n      &:disabled {\n        transform: translateX(-50%);\n      }\n      &:hover:not(:disabled) {\n        transform: translateX(-50%) translateY(-2px);\n      }\n      &:active:not(:disabled) {\n        transform: translateX(-50%) translateY(0);\n      }\n    }\n\n    @include m_tablet {\n      width: calc(100% - 40px);\n      max-width: 400px;\n      font-size: 16px;\n      height: 48px;\n      padding: 16px 32px;\n    }\n  }\n// Onboarding Pages Styles\n.onboarding-page {\n  position: relative;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100vw;\n  background: var(--main-surface-color);\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-bottom: 200px; // Extra padding for scrollability\n\n\n\n\n\n  .onboarding-loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.9);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    backdrop-filter: blur(2px);\n  }\n\n  .personal-details-background {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 1;\n\n    .bg-layer {\n      position: absolute;\n      box-shadow: -2px -2px 20px 0px rgba(34, 92, 180, 0.25);\n\n      &.bg-layer-1 {\n        height: 318px;\n        width: 524px;\n        left: calc(58.33% + 80px);\n        top: 489px;\n        opacity: 0.2;\n        border-radius: 100px;\n        background: linear-gradient(-44.28deg, rgba(216, 220, 227, 1) 2.4%, rgba(0, 103, 255, 1) 98.5%);\n      }\n\n      &.bg-layer-2 {\n        height: 258px;\n        width: 449px;\n        left: calc(66.67% + 10px);\n        top: 529px;\n        opacity: 0.4;\n        border-radius: 80px;\n        background: linear-gradient(-42.72deg, rgba(216, 220, 227, 1) 2.4%, rgba(0, 103, 255, 1) 98.5%);\n      }\n\n      &.bg-layer-3 {\n        height: 198px;\n        width: 375px;\n        left: calc(66.67% + 59px);\n        top: 569px;\n        opacity: 0.8;\n        border-radius: 60px;\n        background: linear-gradient(-40.29deg, rgba(216, 220, 227, 1) 2.4%, rgba(0, 103, 255, 1) 98.5%);\n      }\n\n      &.bg-layer-4 {\n        height: 138px;\n        width: 299px;\n        left: calc(75% - 10px);\n        top: 609px;\n        opacity: 0.12;\n        border-radius: 40px;\n        //background: linear-gradient(-36.51deg, rgba(216, 220, 227, 1) 2.4%, rgba(0, 103, 255, 1) 98.5%);\n      }\n\n      &.bg-layer-5 {\n        height: 80px;\n        width: 224px;\n        left: calc(75% + 40px);\n        top: 648px;\n        opacity: 0.16;\n        border-radius: 20px;\n        background: linear-gradient(-29.73deg, rgba(216, 220, 227, 1) 2.4%, rgba(0, 103, 255, 1) 98.5%);\n      }\n    }\n  }\n\n  .onboarding-header {\n    position: relative;\n    left: 60px;\n    top: 60px;\n    width: 419px;\n    max-width: calc(100% - 120px);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    z-index: 10;\n    margin-bottom: 20px;\n\n    @include m_desktop {\n      left: 40px;\n      max-width: calc(100% - 80px);\n    }\n    @include m_tablet {\n      left: 20px;\n      top: 32px;\n      max-width: calc(100% - 40px);\n      margin-bottom: 0;\n    }\n\n    .step-indicators {\n      position: relative;\n      width: 419px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .step-indicator-wrapper {\n        position: relative;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .step-progress-line {\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 50%;\n          transform: translateY(-50%);\n          height: 6px;\n          background: var(--quartinary-surface-color);\n          z-index: 1;\n          \n          // Progress bar overlay (controlled by JavaScript via CSS variable)\n          &::before {\n            content: '';\n            position: absolute;\n            left: 0;\n            top: 0;\n            height: 100%;\n            width: var(--progress-width, 69px); // Default for step 1, controlled by JS\n            background: var(--accent-primary-blue-color);\n            transition: width 0.3s ease;\n          }\n        }\n\n      .step {\n          position: relative;\n          width: 40px;\n          height: 40px;\n          border-radius: 120px;\n          background: var(--quartinary-surface-color);\n          border: 1px solid var(--border-color);\n          color: var(--quinary-text-color);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n          font-family: 'Semi Sans', sans-serif;\n          font-size: 24px;\n        font-weight: 600;\n          line-height: 1.2;\n          z-index: 2;\n        transition: all 0.3s ease;\n\n        &.completed {\n            background: var(--accent-primary-blue-color);\n            border-color: var(--accent-primary-blue-color);\n            color: var(--main-surface-color);\n            box-shadow: none;\n          }\n\n        &.active {\n            background: var(--accent-primary-blue-color);\n            border-color: var(--accent-primary-blue-color);\n          color: var(--main-surface-color);\n            box-shadow: none;\n          }\n        }\n      }\n    }\n\n    .onboarding-logo {\n      height: 32px;\n      width: 130px;\n      position: relative;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n    }\n\n    // Progress line widths are now controlled by JavaScript\n  }\n\n  .onboarding-form {\n    position: relative;\n    left: 60px;\n    top: 140px;\n    width: calc(100% - 520px); // Leave space for the fixed CTA button on the right\n    max-width: 1320px;\n    display: flex;\n    flex-direction: column;\n    gap: 34px;\n    z-index: 100;\n    margin-bottom: 100px;\n    padding-bottom: 200px; // Prevent fixed CTA from overlapping last form fields\n    overflow-x: hidden;\n\n    // When CTA moves to bottom center, form can use full width\n    @include m_desktop {\n      width: calc(100% - 120px);\n      max-width: none;\n      left: 40px;\n      top: 100px;\n      margin-bottom: 120px;\n      padding-bottom: 120px;\n    }\n    @include m_tablet {\n      width: calc(100% - 40px);\n      left: 20px;\n      top: 53px;\n      gap: 24px;\n      padding-bottom: 100px;\n      margin-bottom: 0;\n    }\n\n    .onboarding-back-arrow {\n      display: flex;\n      .material-symbols-outlined {\n        font-size: 32px;\n        font-weight: 400;\n        color: #101828;\n      }\n    }\n\n    // Shared input styling (prevents duplication across sections)\n    .input-container {\n      gap: 12px;\n      white-space: inherit;\n      position: relative;\n      z-index: 101;\n\n      .input-label {\n        font-family: 'Semi Sans', sans-serif;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.2;\n        color: var(--secondary-text-color);\n        margin-bottom: 0;\n        .required {\n          color: var(--accent-primary-red-color);\n        }\n      }\n\n      .select-field {\n        height: 60px;\n      }\n\n      .input-field {\n        height: 60px;\n        padding: 16px;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        background: var(--primary-surface-color);\n        font-family: 'Medium Sans', sans-serif;\n        font-size: 16px;\n        line-height: 1.25;\n        color: #333b48;\n        z-index: 101;\n        opacity: 1;\n\n        &:disabled {\n          background-color: #f5f5f5 !important;\n          color: #94a0b3 !important;\n          cursor: not-allowed !important;\n          opacity: 0.6 !important;\n          border-color: #e0e0e0 !important;\n        }\n\n        &::placeholder {\n          color: var(--quinary-text-color);\n          font-family: 'Medium Sans', sans-serif;\n          font-size: 16px;\n        }\n\n        &:focus {\n          border-color: #5095fc;\n          outline: none;\n        }\n      }\n    }\n\n    &.educational-form {\n      // Use max-width so the parent's width: calc(100% - 520px) controls the actual width,\n      // preventing overflow into the fixed CTA button on smaller viewports.\n      max-width: 960px;\n    }\n\n    .onboarding-title {\n      margin: 0 0 8px 0; // Add small bottom margin instead of relying on gap\n      font-family: 'General Sans', sans-serif;\n      font-size: 2.25rem;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 120%;\n      background: linear-gradient(90deg, #4a8ff7 0%, #305996 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n    }\n\n    .section-label {\n      font-family: 'Semi Sans', sans-serif;\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.2;\n      color: var(--secondary-text-color);\n      margin-bottom: 12px;\n      display: block;\n\n      .required {\n        color: var(--accent-primary-red-color);\n      }\n    }\n\n    .form-row-1 {\n      display: flex;\n      gap: 16px;\n      align-items: flex-start;\n      position: relative;\n      z-index: 101;\n      margin-bottom: 0; // Remove extra margin\n\n      // Large desktop: all fields in one line (no wrap)\n      @media (min-width: 1601px) {\n        flex-wrap: nowrap;\n      }\n\n      // Mid-large screens: 2 columns to avoid cramping with CTA button\n      @media (min-width: 901px) and (max-width: 1600px) {\n        flex-wrap: wrap;\n        > * {\n          flex: 1 1 calc(50% - 8px);\n          min-width: calc(50% - 8px);\n        }\n      }\n\n      // Medium devices: allow wrapping for 2-column layout\n      @media (min-width: 651px) and (max-width: 900px) {\n        flex-wrap: wrap;\n      }\n\n      // Mobile: single column stacking\n      @media (max-width: 650px) {\n        flex-direction: column;\n        flex-wrap: nowrap;\n      }\n\n      > * {\n        // Medium devices: 2 columns layout\n        @media (min-width: 651px) and (max-width: 900px) {\n          flex: 1 1 calc(50% - 8px);\n          min-width: calc(50% - 8px);\n        }\n        // Mobile: full width\n        @media (max-width: 650px) {\n          flex: 1 1 100%;\n          min-width: 100%;\n        }\n      }\n\n    }\n\n    .form-row-phone {\n      display: flex;\n      gap: 16px;\n      align-items: flex-start;\n      flex-wrap: wrap;\n      position: relative;\n      z-index: 101;\n\n      > * {\n        flex: 1 1 calc(50% - 8px);\n        min-width: calc(50% - 8px);\n      }\n\n      .whatsapp-input-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        height: auto; // Changed from 105px to auto for better fit\n        min-height: 105px;\n\n        .input-container {\n          margin-bottom: 0;\n          white-space: nowrap;\n\n          \n        }\n      \n        .checkbox-container {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          margin-top: 0;\n\n          input {\n            width: 24px  !important;\n            height: 16px;\n            cursor: pointer;\n          }\n\n          label {\n            font-family: 'General Sans', sans-serif;\n            font-size: 14px;\n            line-height: 1.25;\n            color: #333b48;\n            cursor: pointer;\n          }\n        }\n      }\n    }\n\n    .form-row-2 {\n      display: flex;\n      gap: 24px; // Reduced from 40px to make more compact\n      align-items: flex-start;\n      flex-wrap: wrap;\n      position: relative;\n      z-index: 101; // Above layers\n      margin-bottom: 0; // Remove extra margin\n\n      @include respond-to(900px) {\n        flex-direction: column;\n        gap: 24px;\n      }\n\n      .whatsapp-field-wrapper {\n        // Desktop: match gender-section width\n        @media (min-width: 901px) {\n          width: 450px !important;\n          .input-container {\n            .input-label {\n              font-size: 20px;\n              font-weight: 600;\n              line-height: 1.2;\n              color: var(--secondary-text-color);\n              margin-bottom: 0;\n            }\n            .input-field {\n              height: 60px;\n              width: 100%;\n              margin-bottom: 15px;\n            }\n          }\n          .checkbox-container{\n            display: flex;\n            gap: 12px;\n            input {\n              width: 24px  !important;\n            }\n          }\n\n        }\n\n        // Medium devices: full width\n        @media (min-width: 651px) and (max-width: 900px) {\n          width: 100% !important;\n          flex: 1 1 100% !important;\n          max-width: 100% !important;\n        }\n\n      }\n\n      .gender-section {\n        width: 506px;\n        max-width: 100%;\n        margin-bottom: 0;\n        padding-bottom: 0;\n        border-bottom: none;\n        display: flex;\n        flex-direction: column;\n        gap: 8px; // Reduced from 12px\n        position: relative;\n        z-index: 101; // Above layers\n\n        @include respond-to(900px) {\n          width: 100%;\n        }\n\n        .gender-options {\n          display: flex;\n          gap: 10px;\n\n\n          .gender-option {\n            flex: 1 1 auto;\n           \n            padding: 16px;\n            border-radius: 8px;\n            border: 1px solid var(--border-color);\n            background: var(--primary-surface-color);\n            color: var(--quinary-text-color);\n            font-family: 'Medium Sans', sans-serif;\n            font-size: 16px;\n            line-height: 1.25;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            height: 60px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            white-space: nowrap;\n\n            &:hover {\n              border-color: var(--accent-primary-blue-color);\n            }\n\n            &.selected {\n              background: var(--accent-primary-blue-color);\n              border-color: var(--accent-primary-blue-color);\n              color: var(--main-surface-color);\n            }\n          }\n        }\n      }\n\n      .dob-section {\n        margin-bottom: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 8px; // Reduced from 12px\n        position: relative;\n        z-index: 101; // Above layers\n\n        .dob-inputs {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          z-index: 101; // Above layers\n\n          .dob-input {\n            padding: 16px;\n            border-radius: 8px;\n            border: 1px solid var(--border-color);\n            background: var(--primary-surface-color);\n            font-family: 'Medium Sans', sans-serif;\n            font-size: 16px;\n            line-height: 1.25;\n            text-align: left;\n            height: 60px;\n            transition: all 0.2s ease;\n            max-width: 80px;\n            position: relative;\n            z-index: 101; // Above layers\n\n            &:focus {\n              outline: none;\n              border-color: var(--accent-primary-blue-color);\n            }\n\n            &::placeholder {\n              color: var(--quinary-text-color);\n            }\n          }\n\n          .dob-separator {\n            color: var(--quinary-text-color);\n            font-family: 'Medium Sans', sans-serif;\n            font-size: 16px;\n            line-height: 1.25;\n          }\n        }\n      }\n    }\n\n    .social-profiles-section {\n      margin-top: 32px;\n      position: relative;\n      z-index: 101;\n\n      .section-title {\n        font-family: 'Semi Sans', sans-serif;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.2;\n        color: var(--secondary-text-color);\n        margin-bottom: 16px;\n      }\n\n      .social-profiles-row {\n        display: flex;\n        gap: 16px;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        position: relative;\n        z-index: 101;\n\n        > * {\n          flex: 1 1 calc(50% - 8px);\n          min-width: calc(50% - 8px);\n\n          @media (max-width: 650px) {\n            flex: 1 1 100%;\n            min-width: 100%;\n          }\n        }\n\n      }\n    }\n        .checkbox-container {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-top: 8px;\n          input {\n            width: 24px  !important;\n            height: 16px;\n            cursor: pointer;\n          }\n        }\n    .address-section-wrapper {\n      width: 100%;\n      max-width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      position: relative;\n      z-index: 101;\n      margin-bottom: 0;\n\n      @include respond-to(900px) {\n        width: 100%;\n      }\n\n      .address-fields-row {\n        display: flex;\n        gap: 28px;\n        flex-wrap: wrap;\n        position: relative;\n        z-index: 101;\n\n        > * {\n          flex: 1 1 0;\n          min-width: 0;\n          position: relative;\n          z-index: 101;\n        }\n\n        .pincode-input-wrapper {\n          flex: 1 1 0;\n          min-width: 0;\n          position: relative;\n\n          .input-container,\n          > div {\n            width: 100%;\n          }\n\n          .pincode-loading-indicator {\n            display: block;\n            font-size: 12px;\n            color: #5095fc;\n            margin-top: 4px;\n            font-family: 'General Sans', sans-serif;\n          }\n        }\n      }\n    }\n\n    .form-grid {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 24px;\n      margin-bottom: 32px;\n\n      @include respond-to(768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    \n\n    .form-grid-2 {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 40px;\n      margin-bottom: 32px;\n        .input-container {\n          width: 100%;\n        }\n      @include sm_desktop {\n        gap: 24px;\n      }\n      @include respond-to(900px) {\n        grid-template-columns: 1fr;\n        gap: 24px;\n      }\n    }\n\n    .postgraduate-question-section {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      margin-bottom: 32px;\n\n      .postgraduate-question-label {\n        font-family: 'Semi Sans', sans-serif;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.2;\n        color: #444f5f;\n        margin-bottom: 0;\n      }\n\n      .postgraduate-options {\n        display: flex;\n        gap: 10px;\n\n        .postgraduate-option-btn {\n          flex: 1 0 0;\n          height: 60px;\n          padding: 16px;\n          border-radius: 8px;\n          border: 1px solid #d8e3f4;\n          background: white;\n          font-family: 'Medium Sans', sans-serif;\n          font-size: 16px;\n          line-height: 1.25;\n          color: #94a0b3;\n          cursor: pointer;\n          transition: all 0.3s ease;\n\n          &:hover {\n            border-color: var(--accent-primary-blue-color);\n            color: var(--accent-primary-blue-color);\n          }\n\n          &.active {\n            background: #5095fc;\n            border-color: #5095fc;\n            color: var(--main-surface-color);\n          }\n        }\n      }\n    }\n\n    .form-grid-3 {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 24px;\n      margin-bottom: 32px;\n\n      @include respond-to(1024px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n      @include respond-to(600px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .form-grid-1 {\n      margin-bottom: 32px;\n    }\n\n    .input-with-checkbox {\n\n      .checkbox-container {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-top: 8px;\n\n        input[type='checkbox'] {\n          width: 18px;\n          height: 18px;\n          cursor: pointer;\n        }\n\n        label {\n          color: var(--secondary-text-color);\n          font-family: 'General-sans';\n          font-size: 14px;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .education-level-section {\n      margin-bottom: 0;\n      padding-bottom: 0;\n      border-bottom: none;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n\n      .education-level-options {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n        width: 100%;\n\n        .education-option {\n          flex: 1 1 auto;\n          min-width: 140px;\n          padding: 16px;\n          border-radius: 8px;\n          border: 1px solid #d8e3f4;\n          background: white;\n          color: #94a0b3;\n          font-family: 'Medium Sans', sans-serif;\n          font-size: 16px;\n          line-height: 1.25;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          height: 60px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n\n          @include respond-to(900px) {\n            flex: 1 1 calc(50% - 5px);\n            min-width: calc(50% - 5px);\n            font-size: 14px;\n            padding: 12px 8px;\n          }\n\n          &:hover {\n            border-color: #5095fc;\n          }\n\n          &.selected {\n            background: #5095fc;\n            border-color: #5095fc;\n            color: var(--main-surface-color);\n          }\n        }\n      }\n    }\n\n    .work-experience-radio-section {\n      margin-bottom: 40px;\n      padding-bottom: 32px;\n      border-bottom: 1px solid var(--quartinary-surface-color);\n\n      .radio-options {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n\n        .radio-button {\n          padding: 14px 24px;\n          border-radius: 8px;\n          border: 2px solid var(--quartinary-surface-color);\n          background: white;\n          color: var(--secondary-text-color);\n          font-family: 'Semi Sans';\n          font-size: 16px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n\n          &:hover {\n            border-color: var(--accent-primary-blue-color);\n          }\n\n          &.selected {\n            background: var(--accent-primary-blue-color);\n            border-color: var(--accent-primary-blue-color);\n            color: var(--main-surface-color);\n\n            .radio-circle {\n              border-color: white;\n\n              .radio-dot {\n                background: var(--primary-surface-color);\n              }\n            }\n          }\n        }\n\n        .radio-button {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n\n          .radio-circle {\n            width: 20px;\n            height: 20px;\n            border-radius: 50%;\n            border: 2px solid var(--quartinary-surface-color);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.2s ease;\n\n            .radio-dot {\n              width: 10px;\n              height: 10px;\n              border-radius: 50%;\n              background: var(--accent-primary-blue-color);\n            }\n          }\n        }\n      }\n    }\n\n\n    .address-section {\n      margin-bottom: 32px;\n    }\n    \n    // CTC Input Wrapper\n    .ctc-input-wrapper {\n      display: flex;\n      flex-direction: row;\n      gap: 12px;\n      width: 100%;\n      \n      .section-label {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.2;\n        color: #444f5f;\n        margin-bottom: 8px;\n        .required {\n          color: #ef5054;\n        }\n      }\n      .form-row-experience{\n        display: flex;\n        gap: 16px;\n      \n      .input-container {\n        .input-label {\n          font-family: 'Semi Sans', sans-serif;\n          font-size: 20px;\n          font-weight: 600;\n          line-height: 1.2;\n          color: var(--secondary-text-color);\n          margin-bottom: 0;\n        }\n        .select-field {\n          height: 60px;\n        }\n      }\n      }\n      .ctc-input-container {\n        display: flex;\n        align-items: center;\n        height: 60px;\n        border-radius: 8px;\n        border: 1px solid #d8e3f4;\n        background: white;\n        &:focus-within {\n          border-color: #5095fc;\n        }\n        &:has(.ctc-input-field:disabled) {\n          background: #f5f5f5;\n          border-color: #e0e0e0;\n          opacity: 0.6;\n          .ctc-prefix {\n            background: #e0e0e0;\n            color: #94a0b3;\n          }\n          .ctc-suffix {\n            color: #94a0b3;\n          }\n        }\n        .ctc-prefix {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: 100%;\n          width: 35px;\n          padding: 16px 8px;\n          border-right: 1px solid #d8e3f4;\n          border-radius: 8px 0 0 8px;\n          background: #d8e3f4;\n          font-family: 'General Sans', sans-serif;\n          font-size: 14px;\n          font-weight: 600;\n          color: #444f5f;\n        }\n        .ctc-input-field {\n          flex: 1;\n          height: 100%;\n          padding: 16px;\n          border: none;\n          background: transparent;\n          font-family: 'General Sans', sans-serif;\n          font-size: 14px;\n          line-height: 1.25;\n          color: #333b48;\n          outline: none;\n          \n          &:disabled {\n            background-color: #f5f5f5;\n            color: #94a0b3;\n            cursor: not-allowed;\n            opacity: 0.6;\n          }\n          &::placeholder {\n            color: #94a0b3;\n            font-size: 14px;\n          }\n        }\n        .ctc-suffix {\n          padding: 16px;\n          font-family: 'General Sans', sans-serif;\n          font-size: 14px;\n          color: #94a0b3;\n        }\n      }\n\n      .ctc-hint {\n        margin-top: 8px;\n        margin: 0;\n        font-family: 'General Sans', sans-serif;\n        font-size: 16px;\n        line-height: 1.25;\n        color: #444f5f;\n      }\n    }\n    \n    // Employment Section\n    .employment-section {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      width: 100%;\n\n      .section-label {\n        font-family: 'Semi Sans', sans-serif;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.2;\n        color: var(--secondary-text-color);\n        margin-bottom: 0;\n\n        .required {\n          color: var(--accent-primary-red-color);\n          margin-left: 4px;\n        }\n      }\n\n      .employment-options {\n        display: flex;\n        gap: 16px;\n        flex-wrap: wrap;\n\n        .employment-option {\n          flex: 1;\n          min-width: 150px;\n          max-width: 300px;\n          height: 60px;\n          padding: 16px 24px;\n          border-radius: 8px;\n          border: 2px solid var(--quartinary-surface-color);\n          background: var(--primary-surface-color);\n          color: var(--secondary-text-color);\n          font-family: 'Semi Sans', sans-serif;\n          font-size: 16px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 8px;\n          position: relative;\n\n          .check-icon {\n            display: none;\n            font-size: 18px;\n            font-weight: 600;\n          }\n\n          .option-label {\n            flex: 1;\n            text-align: center;\n          }\n\n          &:hover {\n            border-color: var(--accent-primary-blue-color);\n            background: var(--accent-quartinary-blue-color);\n            color: var(--accent-primary-blue-color);\n          }\n\n          &.selected {\n            background: var(--accent-primary-blue-color);\n            border-color: var(--accent-primary-blue-color);\n            color: var(--main-surface-color);\n            box-shadow: 0 2px 8px rgba(80, 149, 252, 0.2);\n\n            .check-icon {\n              display: inline-block;\n            }\n\n            .option-label {\n              font-weight: 600;\n            }\n\n            &:hover {\n              background: var(--accent-primary-blue-color);\n              color: var(--main-surface-color);\n            }\n          }\n        }\n      }\n    }\n\n    .employment-status-section,\n    .postgraduate-question {\n      margin-bottom: 32px;\n\n      .yes-no-options {\n        display: flex;\n        gap: 16px;\n\n        .option-button {\n          flex: 1;\n          max-width: 300px;\n          padding: 16px 32px;\n          border-radius: 8px;\n          border: 2px solid var(--quartinary-surface-color);\n          background: white;\n          color: var(--secondary-text-color);\n          font-family: 'Semi Sans';\n          font-size: 16px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 8px;\n\n          .checkmark {\n            display: none;\n          }\n\n          &:hover {\n            border-color: var(--accent-primary-blue-color);\n          }\n\n          &.selected {\n            background: var(--accent-primary-blue-color);\n            border-color: var(--accent-primary-blue-color);\n            color: var(--main-surface-color);\n\n            .checkmark {\n              display: inline-block;\n            }\n          }\n        }\n      }\n    }\n\n    .postgraduate-fields {\n      margin-top: 32px;\n      padding-top: 32px;\n      border-top: 2px solid var(--quartinary-surface-color);\n\n      .subsection-title {\n        color: var(--primary-text-color);\n        font-family: 'Semi Sans';\n        font-size: 24px;\n        font-weight: 600;\n        margin-bottom: 24px;\n      }\n    }\n\n    .input-with-prefix {\n      position: relative;\n\n      .input-prefix {\n        position: absolute;\n        left: 16px;\n        top: 50%;\n        transform: translateY(-50%);\n        color: var(--secondary-text-color);\n        font-family: 'General-sans';\n        font-size: 16px;\n        font-weight: 600;\n        pointer-events: none;\n      }\n\n      .input-suffix {\n        position: absolute;\n        right: 16px;\n        top: 50%;\n        transform: translateY(-50%);\n        color: var(--secondary-text-color);\n        font-family: 'General-sans';\n        font-size: 14px;\n        pointer-events: none;\n      }\n\n      .input-hint {\n        margin-top: 8px;\n        color: var(--secondary-text-color);\n        font-family: 'General-sans';\n        font-size: 13px;\n      }\n\n      input {\n        padding-left: 40px !important;\n        padding-right: 60px !important;\n      }\n    }\n\n    .subsection-title {\n      color: var(--accent-primary-blue-color);\n      font-family: 'Semi Sans';\n      font-size: 20px;\n      font-weight: 600;\n      margin-bottom: 24px;\n    }\n\n    .work-experience-fields-section {\n      margin-bottom: 40px;\n      padding-bottom: 32px;\n      border-bottom: 1px solid var(--quartinary-surface-color);\n    }\n\n    .resume-section-divider {\n      margin-bottom: 40px;\n      padding-bottom: 32px;\n      border-bottom: 1px solid var(--quartinary-surface-color);\n    }\n\n    .social-section-divider {\n      margin-bottom: 40px;\n    }\n\n\n    .form-actions {\n      margin-top: 48px;\n      padding-top: 32px;\n      border-top: 1px solid #E5EBF4;\n      display: flex;\n      justify-content: space-between;\n      position: relative;\n\n      .back-button {\n        background: transparent;\n        color: var(--accent-primary-blue-color);\n        font-family: 'Semi Sans';\n        font-size: 18px;\n        font-weight: 600;\n        padding: 16px 48px;\n        border-radius: 12px;\n        border: 2px solid var(--accent-primary-blue-color);\n        cursor: pointer;\n        transition: all 0.3s ease;\n\n        &:hover {\n          background: var(--accent-quartinary-blue-color);\n        }\n      }\n\n      .submit-button {\n        position: relative;\n        background: var(--accent-primary-blue-color);\n        color: white;\n        font-family: 'Semi Sans';\n        font-size: 18px;\n        font-weight: 600;\n        padding: 16px 48px;\n        border-radius: 12px;\n        border: none;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        overflow: visible;\n        z-index: 1;\n        \n        // Layered effect - multiple concentric rounded rectangles\n        &::before {\n          content: '';\n          position: absolute;\n          top: -2px;\n          left: -2px;\n          right: -2px;\n          bottom: -2px;\n          border-radius: 14px;\n          background: linear-gradient(135deg, rgba(215, 231, 254, 0.9) 0%, rgba(200, 220, 250, 0.95) 100%);\n          z-index: -1;\n        }\n        \n        &::after {\n          content: '';\n          position: absolute;\n          top: -4px;\n          left: -4px;\n          right: -4px;\n          bottom: -4px;\n          border-radius: 16px;\n          background: linear-gradient(135deg, rgba(230, 242, 255, 0.7) 0%, rgba(215, 231, 254, 0.8) 100%);\n          z-index: -2;\n        }\n        \n        // Additional layered shadow effects for more depth\n        box-shadow: \n          0 0 0 1px rgba(215, 231, 254, 0.7),\n          0 0 0 2px rgba(230, 242, 255, 0.5),\n          0 0 0 3px rgba(240, 247, 255, 0.3),\n          0 4px 12px rgba(80, 149, 252, 0.3);\n\n        &:hover {\n          background: #3d7de0;\n          transform: translateY(-2px);\n          box-shadow: \n            0 0 0 1px rgba(215, 231, 254, 0.8),\n            0 0 0 2px rgba(230, 242, 255, 0.6),\n            0 0 0 3px rgba(240, 247, 255, 0.4),\n            0 8px 16px rgba(80, 149, 252, 0.4);\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    .error-message {\n      color: var(--accent-primary-red-color);\n      font-family: 'General-sans';\n      font-size: 13px;\n      margin-top: 6px;\n      display: block;\n\n      &.section-error {\n        margin-bottom: 16px;\n        color: #e74c3c;\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n\n    .section-heading {\n      margin-top: 24px;\n      margin-bottom: 16px;\n      font-size: 18px;\n      font-weight: 600;\n      color: #333;\n    }\n  }\n}\n.input-field-onboarding {\n  flex: 1 1 0;\n  min-width: 0;\n\n  @include m_desktop {\n    flex: 1 1 calc(50% - 8px);\n    min-width: calc(50% - 8px);\n  }\n}\n\n.form-row-organization {\n  .input-field {\n    height: 60px;\n  }\n}\n\n// ============================================\n// Responsive: hide layered background on smaller screens\n// ============================================\n.onboarding-page {\n  .layered-background-new {\n    @include m_desktop {\n      display: none !important;\n    }\n  }\n\n  // Reposition CTA button on medium screens — avoid overlapping form content\n  .submit-button-figma-new {\n    @include m_desktop {\n      position: fixed !important;\n      bottom: 20px !important;\n      left: 50% !important;\n      right: auto !important;\n      transform: translateX(-50%) !important;\n      width: calc(100% - 80px) !important;\n      max-width: 400px !important;\n      padding: 16px 24px !important;\n      font-size: 18px !important;\n    }\n    @include m_tablet {\n      width: calc(100% - 40px) !important;\n    }\n  }\n\n  // Form row wrapping for medium screens\n  .onboarding-form {\n    .form-row-1 {\n      @include sm_desktop {\n        flex-wrap: wrap;\n        > * {\n          flex: 1 1 calc(50% - 8px);\n          min-width: calc(50% - 8px);\n        }\n      }\n    }\n\n    .form-row-2 {\n      @include m_desktop {\n        flex-direction: column;\n        gap: 24px;\n\n        .whatsapp-field-wrapper {\n          width: 100% !important;\n          flex: 1 1 100% !important;\n          max-width: 100% !important;\n        }\n\n        .gender-section {\n          width: 100%;\n        }\n\n        .dob-section {\n          width: 100%;\n        }\n      }\n    }\n\n    .address-section-wrapper {\n      @include m_desktop {\n        width: 100%;\n      }\n    }\n\n    .ctc-input-wrapper {\n      @include m_desktop {\n        flex-direction: column;\n      }\n    }\n  }\n}\n\n// ============================================\n// Responsive: Welcome page for medium/small screens\n// ============================================\n.onboarding-welcome-page {\n  @include m_desktop {\n    background: linear-gradient(to bottom, #ffffff 0%, #d7e7fe 101.45%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    padding: 20px;\n\n    .layered-background-new {\n      display: none !important;\n    }\n\n    .welcome-logo {\n      position: absolute;\n      left: auto;\n      right: 20px;\n      top: 20px;\n      width: 100px;\n      height: auto;\n    }\n\n    .welcome-start-button {\n      position: relative;\n      bottom: auto;\n      right: auto;\n      transform: none;\n      display: block;\n      width: 100%;\n      max-width: 448px;\n      height: 56px;\n      padding: 16px 32px;\n      font-size: 18px;\n      border-radius: 8px;\n      background: #5095fc;\n      color: #fcfcfc;\n      font-family: 'General Sans', sans-serif;\n      font-weight: 600;\n      line-height: 1.4;\n      border: none;\n      cursor: pointer;\n      margin-top: 16px;\n      order: 3;\n      box-shadow:\n        0 0 20px rgba(80, 149, 252, 0.4),\n        0 4px 12px rgba(80, 149, 252, 0.3),\n        0 2px 4px rgba(0, 0, 0, 0.1);\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n      }\n      &:active:not(:disabled) {\n        transform: translateY(0);\n      }\n      &:disabled {\n        transform: none;\n      }\n    }\n\n    .welcome-greeting {\n      position: relative;\n      left: auto;\n      top: auto;\n      font-size: 34px;\n      text-align: center;\n      width: 100%;\n      max-width: 448px;\n      margin: 0 0 24px 0;\n      font-family: 'General Sans', sans-serif;\n      font-weight: 600;\n      color: #333b48;\n      order: 1;\n    }\n\n    .welcome-content-section {\n      position: relative;\n      left: auto;\n      top: auto;\n      transform: none;\n      width: 100%;\n      max-width: 448px;\n      gap: 24px;\n      margin: 0;\n      order: 2;\n\n      .welcome-title {\n        font-size: 32px;\n        width: 100%;\n        font-family: 'General Sans', sans-serif;\n        font-weight: 600;\n        line-height: 1.2;\n        background: linear-gradient(to right, #4a8ff7, #305996);\n        background-clip: text;\n      }\n\n      .welcome-description {\n        font-size: 20px;\n        width: 100%;\n        max-width: 100%;\n        color: #5d6c83;\n        font-family: 'General Sans', sans-serif;\n        font-weight: 500;\n        margin: 0;\n      }\n    }\n  }\n}\n\n// Review Screen Styles\n.review-screen-container {\n  min-height: 120vh;\n  position: relative;\n  padding: 0;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.review-screen-header {\n  position: absolute;\n  left: 60px;\n  top: 60px;\n  width: 1320px;\n  max-width: calc(100% - 120px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n}\n\n.review-screen-title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.review-screen-title {\n  font-family: 'Arial', sans-serif;\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 36px;\n  color: #101828;\n  margin: 0;\n}\n\n.review-back-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n\n  .material-symbols-outlined {\n    font-size: 24px;\n    color: #101828;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.review-screen-logo {\n  height: 32px;\n  width: 130px;\n  \n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n}\n\n.review-screen-content {\n  position: absolute;\n  left: 60px;\n  top: 136px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: 900px;\n  max-width: calc(100% - 120px);\n  z-index: 1;\n}\n\n.review-section-card {\n  background: white;\n  border: 0.6px solid #7c8ba2;\n  border-radius: 10px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.review-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 28px;\n}\n\n.review-section-title {\n  font-family: 'General Sans', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #101828;\n  margin: 0;\n}\n\n.review-edit-button {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  height: 20px;\n  width: 48.406px;\n  position: relative;\n  \n  .material-symbols-outlined {\n    font-size: 16px;\n    color: #0e6dfb;\n    position: absolute;\n    left: 0;\n    top: 2px;\n  }\n  \n  span:last-child {\n    font-family: 'General Sans', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #0e6dfb;\n    position: absolute;\n    left: 36.5px;\n    top: -1.33px;\n  }\n  \n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.review-section-content {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  position: relative;\n  width: 100%;\n  row-gap: 16px;\n  column-gap: 0;\n}\n\n.review-detail-item {\n  display: flex;\n  flex-direction: column;\n  width: calc(50% - 0px);\n  flex: 0 0 calc(50% - 0px);\n  padding-right: 16px;\n  box-sizing: border-box;\n  \n  &.review-detail-item-full {\n    width: 100%;\n    flex: 1 1 100%;\n    padding-right: 0;\n    padding-left: 0;\n    \n    // Reset padding for full-width items\n    &:nth-child(even) {\n      padding-left: 0;\n    }\n  }\n}\n\n.review-detail-label {\n  font-family: 'General Sans', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #444f5f;\n}\n\n.review-detail-value {\n  font-family: 'General Sans', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: #0e6dfb;\n}\n\n.review-screen-footer {\n  position: absolute;\n  left: calc(87.5% + 8.5px);\n  top: calc(50% + 905px);\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n// Responsive: hide layered background on medium screens for review screen\n.review-screen-container {\n  .layered-background-new {\n    @include m_desktop {\n      display: none !important;\n    }\n  }\n\n  .submit-button-figma-new {\n    @include m_desktop {\n      position: fixed !important;\n      bottom: 20px !important;\n      left: 50% !important;\n      right: auto !important;\n      transform: translateX(-50%) !important;\n      width: calc(100% - 80px) !important;\n      max-width: 400px !important;\n      padding: 16px 24px !important;\n      font-size: 18px !important;\n    }\n    @include m_tablet {\n      width: calc(100% - 40px) !important;\n    }\n  }\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
